var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubblesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 20.06V63C86 64.4905 85.4079 65.92 84.3539 66.9739C83.3 68.0279 81.8705 68.62 80.38 68.62H21.72L4 86.33V20.06C4 18.5695 4.59211 17.14 5.64606 16.086C6.70001 15.0321 8.12948 14.44 9.62 14.44H80.36C81.0997 14.4373 81.8327 14.5808 82.5168 14.862C83.201 15.1433 83.8229 15.5568 84.3469 16.0789C84.8709 16.6011 85.2866 17.2215 85.5703 17.9047C85.854 18.5878 86 19.3203 86 20.06Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8899 63.6699H140.38C141.87 63.6699 143.3 64.262 144.354 65.316C145.408 66.3699 146 67.7994 146 69.2899V135.56L128.29 117.85H69.5199C68.0294 117.85 66.5999 117.258 65.546 116.204C64.492 115.15 63.8999 113.72 63.8999 112.23V76.3099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.79 51.3201H53.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.79 42.45H72.19",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.79 33.5801H72.19",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5898 101.01H113.16",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5898 92.1399H132.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5898 83.27H132.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubblesGrey);
export default __webpack_public_path__ + "static/media/speech_bubbles_grey.09ada3245f03f7f114ff19a589d5fc4a.svg";
export { ForwardRef as ReactComponent };